module.exports = __webpack_public_path__ + "static/media/progman_2.dba70043.ico";